import { decryptData } from "../helpers/encryptor";

export const USER_LOCAL_STORAGE_KEY = "user"

export const getUser = () => {
    const user = localStorage.getItem(USER_LOCAL_STORAGE_KEY);
    return user ? JSON.parse(user) : undefined
}

export const saveUser = (user) => {
    localStorage.setItem(USER_LOCAL_STORAGE_KEY, JSON.stringify(user));
}

export const removeUser = () => {
    localStorage.removeItem(USER_LOCAL_STORAGE_KEY);
}

export const getStoredTokens = () => {
    const encryptedAccessToken = localStorage.getItem('wudify_token');
    return {
        accessToken: encryptedAccessToken ? decryptData(encryptedAccessToken) : null
    };
};

export const setStoredTokens = (accessToken) => {
    localStorage.setItem('wudify_token', accessToken);
};

export const removeStoredTokens = () => {
    localStorage.removeItem('wudify_token');
};

export const setLocalStorageItem = (key, value) => {
    const jsonData = JSON.stringify(value);
    localStorage.setItem(key, jsonData);
};

export const getLocalStorageItem = (key) => {
    const jsonData = localStorage.getItem(key);
    return jsonData ? JSON.parse(jsonData) : null;
};

export const removeLocalStorageItem = (key) => {
    localStorage.removeItem(key);
};